import React, { useEffect, useState , useRef} from "react";
import { Form, Row, Col, Button, Container, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatDate, encryptId, decryptId } from "../utils/helpers";

const API_URL = process.env.REACT_APP_API_URL;

function Literature_Master_Edit() {

    const navigate = useNavigate();

    const { master_id } = useParams();

    const decodedId = decodeURIComponent(master_id);
    const id_master = decryptId(decodedId);
    const alertShown = useRef(false);

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [comment, setComment] = useState("");
    const [literature, setLiterature] = useState("");
    const { user: loggedUser } = useAuth();




    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/literature_master_data_id_wise/${id_master}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                const data = res.data.data_entry;

                setLiterature(data.literature_name || "");
                setComment(data.remark || "");
            })
            .catch(err => console.error(err));
    }, [id_master]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                literature,
                remark: comment
            };

            const response = await axios.post(
                `${API_URL}/update_literature_master/${id_master}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            if (response.data.status) {
                setSuccessMsg(response.data.message);
                setErrorMsg("");

                setTimeout(() => {
                    navigate("/Literature_Master_List");
                }, 1000);
            } else {
                setErrorMsg("Update failed");
            }

        } catch (error) {
            console.error(error);
            setErrorMsg("Update failed");
            setTimeout(() => setErrorMsg(""), 2000);
        }
    };




    return (
        <Container className="mt-4">
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <h3>Update Literature Master</h3>



                <div className="d-flex gap-2">  <Link className="btn btn-sm btn-primary " to="/Literature_Master">Add New Data</Link>
                    <Link className="btn btn-primary btn-sm  mt-md-0" to="/Literature_Master_List">
                        List
                    </Link></div>

            </div>

            <Form autoComplete="off" onSubmit={handleSubmit}>



                <Row className="mt-4">
                    <Col xs={12}>
                        <Form.Label className="fw-semibold">Literature Name</Form.Label>


                        <Form.Control


                            value={literature}
                            onChange={(e) => setLiterature(e.target.value)}
                        />

                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12}>
                        <FloatingLabel label="Enter Comments">
                            <Form.Control
                                as="textarea"
                                style={{ height: "80px" }}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col className="text-center">
                        <Button type="submit" variant="primary">
                            Update
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

export default Literature_Master_Edit;
